import React, { useState, useEffect } from "react";
import { TextField, Button, Container, Typography, Box } from "@mui/material";
import styled from "styled-components";
import API from "../../../utils/api";
import MenuItem from "@mui/material/MenuItem";

const FormContainer = styled(Container)`
  background-color: #1b1a2ea9;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0px 10px 10px 0px rgba(9, 5, 29, 0.171);
  backdrop-filter: blur(15px);
  color: white;
`;

const StyledTextField = styled(TextField)`
  & .MuiInputBase-root {
    color: white;
  }
  & .MuiInputLabel-root {
    color: white;
  }
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: white;
    }
    &:hover fieldset {
      border-color: #c770f0;
    }
    &.Mui-focused fieldset {
      border-color: #c770f0;
    }
  }
  margin-bottom: 1rem;
`;

const StyledButton = styled(Button)`
  background-color: #623686;
  color: white;
  margin-left: 1rem;
  margin-right: 1rem;
  &:hover {
    background-color: #6d20c5d7;
  }
`;
const categories = [
  {
    value: "parent",
    label: "Parent",
  },
  {
    value: "special",
    label: "Special",
  },
];
const egdeTypes = [
  {
    value: "normal",
    label: "Normal",
  },
  {
    value: "long",
    label: "Long",
  },
  {
    value: "special",
    label: "Special",
  },
];
const AddToGraph = () => {
  const [nodeData, setNodeData] = useState({
    label: "",
    type: "",
  });
  const [update, setUpdate] = useState({
    id: "",
    newLabel: "",
  });
  const [egdeData, setEdgeData] = useState({
    to: "",
    from: "",
    label: "",
    type: "normal",
  });
  const [nodes, setNodes] = useState([]);
  useEffect(() => {
    // Load initial data on component mount
    API.get("/api/learning/getNodes")
      .then((res) => res.data)
      .then((response) => {
        setNodes(response.data);
      })
      .catch((error) => {
        console.error("There was an error fetching the initial data!", error);
      });
  }, []);

  const handleNodeDataChange = (e) => {
    setNodeData({ ...nodeData, [e.target.name]: e.target.value });
  };
  const handleEdgeDataChange = (e) => {
    setEdgeData({ ...egdeData, [e.target.name]: e.target.value });
  };
  const handleUpdateDataChange = (e, name = null) => {
    if (name) setUpdate({ newLabel: name, [e.target.name]: e.target.value });
    else setUpdate({ ...update, [e.target.name]: e.target.value });
  };
  const addNode = async (e) => {
    e.preventDefault();
    try {
      await API.post("/api/learning/addNode", {
        ...nodeData,
      }).then(() => {
        setNodeData({
          label: "",
          type: "",
        });
      });
      alert("Node Added Successfully");
    } catch (error) {
      console.error(error);
      alert("Error submitting Node");
    }
  };
  const addEdge = async (e) => {
    e.preventDefault();
    try {
      await API.post("/api/learning/addEdge", {
        ...egdeData,
      });
      alert("Edge Added Successfully");
    } catch (error) {
      console.error(error);
      alert("Error submitting Edge");
    }
  };
  const updateNode = async (e) => {
    e.preventDefault();
    try {
      await API.post("/api/learning/updateNode", update);
      alert("Node Updated Successfully");
    } catch (error) {
      console.error(error);
      alert("Error submitting Node");
    }
  };
  return (
    <Container fluid className="resume-section">
      <FormContainer maxWidth="md">
        <Typography variant="h4" gutterBottom className="purple">
          Knowledge Graph
        </Typography>
        <form onSubmit={addNode}>
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Name"
            name="label"
            value={nodeData.label}
            onChange={handleNodeDataChange}
            required
          />
          <StyledTextField
            size="small"
            fullWidth
            select
            variant="outlined"
            label="Category"
            name="type"
            value={nodeData.type}
            onChange={handleNodeDataChange}
            required
          >
            {categories.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </StyledTextField>
          <Box mt={2}>
            <StyledButton variant="contained" type="submit">
              Add Node
            </StyledButton>
          </Box>
          <br />
          <br />
        </form>
        <hr />
        <hr />
        <form onSubmit={addEdge}>
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Name"
            name="label"
            value={egdeData.label}
            onChange={handleEdgeDataChange}
          />
          <StyledTextField
            size="small"
            fullWidth
            select
            variant="outlined"
            label="Edge Type"
            name="type"
            value={egdeData.type}
            defaultValue="normal"
            onChange={handleEdgeDataChange}
            required
          >
            {egdeTypes.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </StyledTextField>
          <StyledTextField
            size="small"
            fullWidth
            select
            variant="outlined"
            label="From"
            name="from"
            value={egdeData.from}
            onChange={handleEdgeDataChange}
            required
          >
            {nodes.map((option) => (
              <MenuItem key={option.value} value={option._id}>
                {option.label}
              </MenuItem>
            ))}
          </StyledTextField>
          <StyledTextField
            size="small"
            fullWidth
            select
            variant="outlined"
            label="To"
            name="to"
            value={egdeData.to}
            onChange={handleEdgeDataChange}
            required
          >
            {nodes.map((option) => (
              <MenuItem key={option.value} value={option._id}>
                {option.label}
              </MenuItem>
            ))}
          </StyledTextField>
          <Box mt={2}>
            <StyledButton variant="contained" type="submit">
              Add Edge
            </StyledButton>
          </Box>
        </form>
        <br />
        <br />
        <hr />
        <hr />
        <form onSubmit={updateNode}>
          <StyledTextField
            size="small"
            fullWidth
            select
            variant="outlined"
            label="Node"
            name="node"
            value={update.node}
            onChange={(e) => {
              const selectedNodeId = e.target.value;
              const selectedOption = nodes.find(
                (option) => option._id === selectedNodeId
              );
              handleUpdateDataChange(e, selectedOption.label);
            }}
            required
          >
            {nodes.map((option) => (
              <MenuItem key={option.value} value={option._id}>
                {option.label}
              </MenuItem>
            ))}
          </StyledTextField>
          <StyledTextField
            size="small"
            fullWidth
            variant="outlined"
            label="Name"
            name="newLabel"
            value={update.newLabel}
            onChange={handleUpdateDataChange}
            required
          />
          <Box mt={2}>
            <StyledButton variant="contained" type="submit">
              Update Node
            </StyledButton>
          </Box>
        </form>
      </FormContainer>
    </Container>
  );
};

export default AddToGraph;
